import Put from "../api/Put";
import { UPDATE_APPOINTMENT_SIN_TOKEN } from "../api/Routes";

export const setTimeAppointmentSinToken = (idCita, userType, isStart, arrVideoCall) =>{
    let index = arrVideoCall.findIndex(el=>el.userType===userType && el.initVideo === isStart);

    if(index < 0){
        let d = {
            id: idCita,
            videoCalls: [{
                id: '',
                initVideo: isStart,
                userType: userType
            }]
        }

        Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: d, header: false})
        .then(response=>{
           // console.log(response)
        })
        .catch(error=>{
            console.log(error)
        })
    }    
}